module.exports = __webpack_public_path__ + "static/img/case-7luotu.59864dc3.jpg";